import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { Action } from '@ngrx/store';
import {
  GET_BETA_TESTER,
  storeBetaTesterAction,
} from '../actions/config.actions';
import { map, mergeMap } from 'rxjs/operators';
import { BetaTesterService } from '../beta-tester.service';
import { PayloadAction } from '../types/payload-action';
import { BetaFeatureType } from '../types/beta-feature-type';
import { BetaTesterDto } from '../types/BetaTesterDto';

@Injectable()
export class ConfigEffects {
  constructor(
    private actions$: Actions,
    private betaTesterService: BetaTesterService
  ) {}

  @Effect()
  getBetaTester: Observable<Action> = this.actions$.pipe(
    ofType(GET_BETA_TESTER),
    mergeMap((action: PayloadAction<BetaFeatureType>) =>
      this.betaTesterService.isBetaTester(action.payload)
    ),
    map((data: BetaTesterDto) => storeBetaTesterAction(data))
  );
}



// WEBPACK FOOTER //
// ./ts/app/shared/effects/config.effects.ts